module.exports = __webpack_public_path__ + "img/mt.75f348c6.svg";